import { z } from 'zod';

export const updateSupervisorSchema = z.object({
  firstName: z.string().min(4, "الاسم يجب أن يحتوي على ما لا يقل عن اربعه احرف"),
  password: z.string().refine((data) => data === '' || data.length >= 8, {
    message: 'كلمة المرور يجب أن تحتوي على ما لا يقل عن ثمانيه أحرف"',
  }),
  
});